"use client";

import { useEffect } from "react";
import Link from "next/link";

export default function MindalooError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (typeof window !== "undefined" && process.env.NODE_ENV === "development") {
      console.error("Mindaloo error:", error);
    }
  }, [error]);

  return (
    <div className="mindaloo-app min-h-[100dvh] flex flex-col items-center justify-center px-6 text-center">
      <div className="glass-card dark:glass-card-dark rounded-3xl p-8 max-w-md w-full border border-white/20">
        <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500 flex items-center justify-center mx-auto mb-6">
          <span className="text-3xl">🧿</span>
        </div>
        <h1 className="text-2xl font-bold text-white mb-2">Mindaloo paused</h1>
        <p className="text-white/70 mb-8">
          Something went wrong inside the cognition shell. You can try again or return to the start.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={reset}
            className="px-6 py-3 rounded-xl bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 text-white font-semibold hover:from-indigo-600 hover:via-purple-600 hover:to-pink-600 transition-all duration-200"
          >
            Try again
          </button>
          <Link
            href="/start"
            className="px-6 py-3 rounded-xl border border-white/20 hover:bg-white/10 text-white font-medium transition text-center"
          >
            Go to start
          </Link>
        </div>
        {error.digest && (
          <p className="mt-6 text-white/40 text-xs font-mono">Digest: {error.digest}</p>
        )}
      </div>
    </div>
  );
}
